import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
/**
 * Central pipe to safely render:
 *  - Rich text HTML (inline CSS allowed)
 *  - Plain text safely escaped
 *  - Scripts/XSS blocked
 */
@Pipe({
    name: 'safeRichText'
})
export class SafeRichTextPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(input: string): SafeHtml {
        if (!input) return '';
        // Remove <script> tags (prevents XSS)
        let clean = input.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
        // Remove on* event handlers like onclick=, onerror= etc.
        clean = clean.replace(/\son\w+="[^"]*"/gi, '');
        //Remove javascript: URLs
        clean = clean.replace(/href="javascript:[^"]*"/gi, 'href="#"');
        clean = clean.replace(/src="javascript:[^"]*"/gi, 'src=""');

        return this.sanitizer.bypassSecurityTrustHtml(clean);
    }
}